module.exports = __webpack_public_path__ + "static/media/neibujiangshishenqingbia.d96aeff5.png";